const translations = {
  // Navigation
  "nav.successStories": "Success Stories",
  "nav.startups": "Startups",
  "nav.innovations": "Innovations",
  "nav.femmes": "Femmes",
  "nav.diaspora": "Diaspora",
  "nav.more": "Plus",
  "nav.jeunesTalents": "Jeunes Talents",
  "nav.interviews": "Interviews Exclusives",
  "nav.opportunites": "Opportunités",
  "nav.formations": "Formations",
  "nav.apropos": "À propos",
  "nav.search": "Rechercher",
  "nav.searchGlobal": "Recherche globale",
  "nav.searchPlaceholder": "Rechercher une histoire, un entrepreneur, un pays...",
  "nav.popular": "Populaire :",

  // Hero
  "hero.tagline": "Le média qui donne envie d'entreprendre en Afrique",
  "hero.taglineMobile": "Wazi Stories Afrique",
  "hero.headline1": "L'Afrique",
  "hero.headline2": "qui gagne.",
  "hero.subtitle": "500+ success stories, interviews exclusives, opportunités de financement et formations pour entrepreneurs africains — tout en un seul endroit.",
  "hero.cta.explore": "Explorer les stories",
  "hero.cta.interviews": "Voir les interviews",
  "hero.quickLinks.interviews.label": "Interviews",
  "hero.quickLinks.interviews.sublabel": "Exclusives",
  "hero.quickLinks.interviews.badge": "LIVE",
  "hero.quickLinks.opportunites.label": "Opportunités",
  "hero.quickLinks.opportunites.sublabel": "Jobs & Funding",
  "hero.quickLinks.opportunites.badge": "Nouveau",
  "hero.quickLinks.formations.label": "Formations",
  "hero.quickLinks.formations.sublabel": "Salesforce · Odoo",
  "hero.quickLinks.formations.badge": "Wazi",
  "hero.featured.label": "Story du moment",
  "hero.featured.read": "Lire",
  "hero.stats.stories": "Success Stories",
  "hero.stats.interviews": "Interviews vidéo",
  "hero.stats.opportunites": "Opportunités actives",
  "hero.stats.formations": "Formations",
  "hero.stats.pays": "Pays africains",
  "hero.stats.lecteurs": "Lecteurs mensuels",

  // Categories
  "categories.title": "Explorer par Thème",
  "categories.subtitle": "Plongez dans les histoires qui vous inspirent",
  "categories.articles": "articles",
  "categories.newRubriques": "Nouvelles rubriques",
  "categories.tagline": "Le média qui donne envie d'entreprendre",
  "categories.interviews.desc": "Les grands entrepreneurs se confient",
  "categories.opportunites.desc": "Jobs, financements & appels à projets",
  "categories.formations.desc": "Salesforce, Odoo & bootcamp exclusif",
  "categories.interviews.badge": "LIVE",
  "categories.opportunites.badge": "Nouveau",
  "categories.formations.badge": "Wazi Partner",

  // Trending
  "trending.title": "À la une",
  "trending.subtitle": "Les histoires qui font l'actualité entrepreneuriale africaine",
  "trending.recent": "Les plus récents",
  "trending.popular": "Les plus lus",
  "trending.viewAll": "Voir tous les articles",
  "trending.recent.badge": "Récent",

  // Sections
  "section.successStories.title": "Success Stories",
  "section.successStories.subtitle": "Des parcours extraordinaires qui prouvent que tout est possible",
  "section.startups.title": "Startups Africaines",
  "section.startups.subtitle": "Les entreprises qui façonnent l'avenir du continent",
  "section.femmes.title": "Femmes Entrepreneures",
  "section.femmes.subtitle": "Elles bâtissent l'Afrique de demain avec audace et détermination",
  "section.innovations.title": "Innovations & Inventions",
  "section.innovations.subtitle": "L'Afrique invente les solutions de demain",
  "section.jeunesTalents.title": "Jeunes Talents",
  "section.jeunesTalents.subtitle": "La nouvelle génération qui réinvente l'Afrique",
  "section.diaspora.title": "Diaspora Africaine",
  "section.diaspora.subtitle": "Ils portent l'Afrique dans leur cœur et leurs projets",
  "section.interviews.title": "Interviews Exclusives",
  "section.interviews.subtitle": "Les grands entrepreneurs africains se confient",
  "section.opportunites.title": "Opportunités",
  "section.opportunites.subtitle": "Jobs, financements et appels à projets pour entrepreneurs africains",
  "section.formations.title": "Formations",
  "section.formations.subtitle": "Développez vos compétences avec nos partenaires certifiés",
  "section.viewAll": "Voir tout",
  "section.discover": "Découvrir",
  "section.read": "Lire",

  // Article
  "article.readTime": "min de lecture",
  "article.views": "vues",
  "article.source": "Article original",
  "article.sourceDesc": "Ce contenu est un résumé éditorial. Pour lire l'histoire complète, consultez la source originale sur",
  "article.readFull": "Lire l'article complet sur",
  "article.share": "Partager cette histoire :",
  "article.related": "Articles similaires",
  "article.notFound": "Article introuvable",
  "article.backHome": "Retour à l'accueil",
  "article.fullAnalysis": "Analyse complète",

  // Listing
  "listing.results": "histoire trouvée",
  "listing.results_plural": "histoires trouvées",
  "listing.noResults": "Aucun résultat trouvé",
  "listing.noResultsHint": "Essayez d'autres filtres ou mots-clés",
  "listing.searchPlaceholder": "Rechercher par nom, entrepreneur...",
  "listing.allCountries": "Tous les pays",
  "listing.allSectors": "Tous les secteurs",
  "listing.reset": "Réinitialiser",
  "listing.showFilters": "Afficher les filtres",
  "listing.hideFilters": "Masquer",
  "listing.activeFilters": "Filtres actifs",
  "listing.filterHint": "Filtrer par pays / secteur",

  // Listing page configs
  "listing.successStories.title": "Success Stories",
  "listing.successStories.subtitle": "Des parcours extraordinaires qui prouvent que tout est possible en Afrique",
  "listing.startups.title": "Startups Africaines",
  "listing.startups.subtitle": "Les entreprises innovantes qui façonnent l'avenir du continent africain",
  "listing.innovations.title": "Innovations & Inventions",
  "listing.innovations.subtitle": "L'Afrique invente les solutions de demain pour le monde entier",
  "listing.femmes.title": "Femmes Entrepreneures",
  "listing.femmes.subtitle": "Elles bâtissent l'Afrique de demain avec audace et détermination",
  "listing.jeunesTalents.title": "Jeunes Talents",
  "listing.jeunesTalents.subtitle": "La nouvelle génération qui réinvente l'Afrique avec créativité",
  "listing.diaspora.title": "Diaspora Africaine",
  "listing.diaspora.subtitle": "Ils ont quitté le continent mais portent l'Afrique dans leur cœur et leurs projets",

  // Submit & Newsletter
  "submit.badge": "Votre histoire compte",
  "submit.title": "Vous avez une histoire inspirante à partager ?",
  "submit.subtitle": "Soumettez votre parcours entrepreneurial et inspirez des milliers de jeunes africains. Chaque histoire compte, chaque réussite mérite d'être célébrée.",
  "submit.cta": "Soumettre mon histoire",
  "submit.stat.readers": "Lecteurs mensuels",
  "submit.stat.shares": "Partages WhatsApp",
  "submit.stat.countries": "Pays touchés",
  "newsletter.title": "Restez Inspiré chaque semaine",
  "newsletter.subtitle": "Recevez les meilleures success stories africaines directement dans votre boîte mail. Gratuit, sans spam.",
  "newsletter.placeholder": "Votre adresse email",
  "newsletter.cta": "S'inscrire",
  "newsletter.success": "Merci ! Vous recevrez les meilleures stories chaque semaine.",
  "newsletter.error": "Une erreur est survenue. Réessayez.",
  "newsletter.legal": "En vous inscrivant, vous acceptez de recevoir notre newsletter hebdomadaire. Désabonnement possible à tout moment.",

  // Footer
  "footer.tagline": "Le média qui donne envie d'entreprendre en Afrique",
  "footer.desc": "Success stories, interviews exclusives, opportunités et formations pour entrepreneurs africains.",
  "footer.explore": "Explorer",
  "footer.resources": "Ressources",
  "footer.contact": "Contact",
  "footer.partners": "Partenaires formations",
  "footer.copyright": "© 2026 Wazi Stories Afrique. Tous droits réservés.",
  "footer.motto": "Le média qui donne envie d'entreprendre en Afrique",
  "footer.links.successStories": "Success Stories",
  "footer.links.startups": "Startups Africaines",
  "footer.links.innovations": "Innovations & Inventions",
  "footer.links.femmes": "Femmes Entrepreneures",
  "footer.links.jeunesTalents": "Jeunes Talents",
  "footer.links.diaspora": "Diaspora Africaine",
  "footer.links.interviews": "Interviews Exclusives",
  "footer.links.opportunites": "Opportunités",
  "footer.links.formations": "Formations",
  "footer.links.recherche": "Recherche globale",
  "footer.links.soumettre": "Soumettre une histoire",
  "footer.links.apropos": "À propos",

  // Startup card
  "startup.discover": "Découvrir",
  "startup.source": "Source:",

  // Femme card
  "femme.read": "Lire",

  // Search page
  "search.title": "Recherche",
  "search.placeholder": "Rechercher une histoire, un entrepreneur, un pays...",
  "search.results": "résultat pour",
  "search.results_plural": "résultats pour",
  "search.noResults": "Aucun résultat pour",
  "search.noResultsHint": "Essayez d'autres mots-clés",
  "search.allCategories": "Toutes catégories",

  // Soumettre page
  "soumettre.title": "Soumettre une histoire",
  "soumettre.subtitle": "Partagez votre parcours entrepreneurial avec notre communauté",

  // Opportunites
  "opportunites.title": "Opportunités",
  "opportunites.subtitle": "Jobs, financements et appels à projets pour entrepreneurs africains",

  // Formations
  "formations.title": "Formations",
  "formations.subtitle": "Développez vos compétences avec nos partenaires certifiés",

  // Interviews
  "interviews.title": "Interviews Exclusives",
  "interviews.subtitle": "Les grands entrepreneurs africains se confient",

  // A propos
  "apropos.title": "À propos de Wazi Stories",

  // Language switcher
  "lang.fr": "Français",
  "lang.en": "English",

  // SectionHeader
  "section.viewAll.label": "Voir tout",

  // Interviews section
  "interviews.exclusive.badge": "Exclusif",
  "interviews.subtitle.wazi": "Les grands entrepreneurs africains se confient à Wazi Stories",
  "interviews.viewAll": "Toutes les interviews",
  "interviews.viewAllFull": "Voir toutes les interviews",
  "interviews.views": "vues",

  // Opportunites section
  "opportunites.filter.all": "Tout",
  "opportunites.filter.funding": "Financements",
  "opportunites.filter.job": "Emplois",
  "opportunites.filter.appel": "Appels à projets",
  "opportunites.type.job": "Emploi",
  "opportunites.type.funding": "Financement",
  "opportunites.type.appel": "Appel à projets",
  "opportunites.remote": "Remote",
  "opportunites.viewAll": "Voir toutes les opportunités",

  // Formations section
  "formations.partner.title": "Partenariats Wazi — Formations certifiantes",
  "formations.partner.desc": "Salesforce, Odoo et notre bootcamp exclusif disponibles avec accompagnement Wazi",
  "formations.partner.cta": "Découvrir les formations",
  "formations.certified": "Certifiant",
  "formations.register": "S'inscrire",
  "formations.level.beginner": "Débutant",
  "formations.level.intermediate": "Intermédiaire",
  "formations.level.advanced": "Avancé",

  // Diaspora section
  "diaspora.alsoIn": "Et aussi dans la diaspora...",
  "diaspora.cta.title": "Vous faites partie de la diaspora ?",
  "diaspora.cta.desc": "Partagez votre parcours et inspirez la prochaine génération d'entrepreneurs africains.",
  "diaspora.cta.btn": "Soumettre mon histoire",
  "diaspora.world": "Monde",

  // ArticleKeyPoints
  "keypoints.impact": "Impact en chiffres",
  "keypoints.keypoints": "Points clés à retenir",
  "keypoints.quote": "Citation",

  // ArticleCard
  "card.share.whatsapp": "Partager sur WhatsApp",
  "card.share.linkedin": "Partager sur LinkedIn",

  // MobileBottomNav
  "mobile.home": "Accueil",
  "mobile.stories": "Stories",
  "mobile.search": "Recherche",
  "mobile.opportunites": "Opportunités",
  "mobile.more": "Plus",

  // Interviews page
  "interviews.page.title": "Interviews Exclusives — Entrepreneurs africains | Wazi Stories Afrique",
  "interviews.page.desc": "Des conversations profondes avec les plus grands entrepreneurs africains. Sans filtre, sans langue de bois.",
  "interviews.hero.badge": "Exclusif",
  "interviews.hero.subtitle": "Les grands entrepreneurs africains se confient à Wazi Stories. Des conversations profondes, sans filtre.",
  "interviews.stats.total": "Interviews",
  "interviews.stats.views": "Vues totales",
  "interviews.stats.countries": "Représentés",
  "interviews.featured.label": "Interview du moment",
  "interviews.all.label": "Toutes les interviews",
  "interviews.meta.views": "vues",

  // Opportunites page
  "opportunites.page.title": "Opportunités — Jobs, Financements & Appels à projets | Wazi Stories",
  "opportunites.page.desc": "Les meilleures opportunités pour entrepreneurs et professionnels africains, mises à jour chaque semaine.",
  "opportunites.hero.title": "Jobs, Financements & Appels à projets",
  "opportunites.hero.subtitle": "Les meilleures opportunités pour entrepreneurs et professionnels africains, mises à jour chaque semaine.",
  "opportunites.filter.all.icon": "Toutes",
  "opportunites.results": "opportunité disponible",
  "opportunites.results_plural": "opportunités disponibles",
  "opportunites.noResults": "Aucune opportunité trouvée",
  "opportunites.search.placeholder": "Rechercher une opportunité, organisation, secteur...",
  "opportunites.cta.title": "Vous avez une opportunité à partager ?",
  "opportunites.cta.desc": "Publiez votre offre d'emploi, appel à projets ou programme de financement gratuitement sur Wazi.",
  "opportunites.cta.btn": "Soumettre une opportunité",
  "opportunites.stats.funding": "Financements",
  "opportunites.stats.jobs": "Emplois",
  "opportunites.stats.appels": "Appels",

  // Formations page
  "formations.page.title": "Formations — Salesforce, Odoo & Bootcamp Wazi | Wazi Stories",
  "formations.page.desc": "Les meilleures formations certifiantes pour entrepreneurs africains : Salesforce, Odoo, Google, Microsoft et le bootcamp exclusif Wazi.",
  "formations.hero.badge": "Formations certifiantes",
  "formations.hero.title": "Montez en compétences",
  "formations.hero.subtitle": "Salesforce, Odoo, Google, Microsoft et le bootcamp exclusif Wazi — les meilleures formations pour entrepreneurs africains.",
  "formations.wazi.title": "Partenariats Wazi Stories",
  "formations.wazi.desc": "Salesforce Trailhead, Odoo Learning et notre bootcamp exclusif avec accompagnement personnalisé",
  "formations.wazi.cta": "Voir les formations Wazi",
  "formations.search.placeholder": "Rechercher une formation...",
  "formations.filter.allLevels": "Tous niveaux",
  "formations.filter.allFormats": "Tous formats",
  "formations.filter.online": "En ligne",
  "formations.filter.inPerson": "Présentiel",
  "formations.filter.hybrid": "Hybride",
  "formations.filter.wazi": "Wazi Partner",
  "formations.filter.toggle": "Filtres",
  "formations.filter.hide": "Masquer",
  "formations.filter.reset": "Réinitialiser",
  "formations.filter.active": "filtre actif",
  "formations.filter.active_plural": "filtres actifs",
  "formations.filter.hint": "Filtrer les formations",
  "formations.results": "formation disponible",
  "formations.results_plural": "formations disponibles",
  "formations.noResults": "Aucune formation trouvée",
  "formations.cta.title": "Vous proposez une formation ?",
  "formations.cta.desc": "Rejoignez l'écosystème Wazi et touchez des milliers d'entrepreneurs africains.",
  "formations.cta.btn": "Proposer une formation",

  // À propos page
  "apropos.hero.badge": "Notre histoire",
  "apropos.hero.headline": "Nous racontons l'Afrique qui gagne",
  "apropos.hero.subtitle": "Wazi Stories Afrique est née d'une conviction simple : l'Afrique regorge de talents, d'innovateurs et d'entrepreneurs extraordinaires qui méritent d'être célébrés.",
  "apropos.mission.title": "Notre mission",
  "apropos.mission.p1": "Wazi Stories Afrique est la référence digitale des success stories africaines. Nous agrégeons, mettons en avant et valorisons des contenus positifs sur l'entrepreneuriat africain — des success stories, des innovations, des startups prometteuses et des parcours inspirants.",
  "apropos.mission.p2": "Notre objectif est simple : inspirer la jeunesse africaine, valoriser les talents locaux et connecter les opportunités à travers le continent. Parce que chaque histoire de réussite africaine mérite d'être racontée et partagée.",
  "apropos.mission.cta.stories": "Découvrir les stories",
  "apropos.mission.cta.submit": "Soumettre une histoire",
  "apropos.mission.badge.stories": "Success stories publiées",
  "apropos.mission.badge.countries": "Pays africains représentés",
  "apropos.stats.title": "Wazi Stories en chiffres",
  "apropos.stats.subtitle": "Une plateforme qui grandit avec l'Afrique",
  "apropos.stats.stories": "Success stories publiées",
  "apropos.stats.countries": "Pays africains représentés",
  "apropos.stats.readers": "Lecteurs mensuels",
  "apropos.stats.shares": "Partages WhatsApp / mois",
  "apropos.stats.innovations": "Innovations documentées",
  "apropos.stats.women": "Histoires de femmes entrepreneures",
  "apropos.values.title": "Nos valeurs",
  "apropos.values.subtitle": "Ces principes guident chaque décision éditoriale et chaque histoire que nous choisissons de raconter",
  "apropos.values.positivity.title": "Positivité",
  "apropos.values.positivity.desc": "Nous ne racontons que des histoires inspirantes et constructives. L'Afrique a besoin de récits qui élèvent, pas qui abaissent.",
  "apropos.values.authenticity.title": "Authenticité",
  "apropos.values.authenticity.desc": "Chaque histoire est vérifiée et sourcée. Nous citons toujours l'origine des articles et redirigeons vers les sources originales.",
  "apropos.values.inclusion.title": "Inclusion",
  "apropos.values.inclusion.desc": "Nous valorisons toutes les formes d'entrepreneuriat : startup tech, PME locale, artisanat, agriculture, diaspora, femmes, jeunes.",
  "apropos.values.panafrican.title": "Panafricanisme",
  "apropos.values.panafrican.desc": "Nous couvrons les 54 pays africains sans distinction. Chaque coin du continent a ses héros qui méritent d'être connus.",
  "apropos.values.innovation.title": "Innovation",
  "apropos.values.innovation.desc": "Nous mettons en avant les solutions africaines aux problèmes africains. L'Afrique invente, crée et innove chaque jour.",
  "apropos.values.community.title": "Communauté",
  "apropos.values.community.desc": "Nous construisons un espace où entrepreneurs, investisseurs et lecteurs se connectent, s'inspirent et se soutiennent mutuellement.",
  "apropos.team.title": "L'équipe",
  "apropos.team.subtitle": "Une équipe panafricaine passionnée, répartie sur tout le continent, unie par une même conviction",
  "apropos.team.join.title": "Rejoignez l'équipe",
  "apropos.team.join.desc": "Vous êtes journaliste, développeur, designer ou passionné d'entrepreneuriat africain ? Nous recrutons des correspondants dans toute l'Afrique.",
  "apropos.team.join.cta": "Nous contacter",
  "apropos.timeline.title": "Notre parcours",
  "apropos.timeline.subtitle": "De l'idée à la référence africaine",
  "apropos.partners.title": "Nos partenaires",
  "apropos.partners.subtitle": "Ensemble pour valoriser l'entrepreneuriat africain",
  "apropos.partners.cta.text": "Vous souhaitez devenir partenaire de Wazi Stories Afrique ?",
  "apropos.partners.cta.btn": "Devenir partenaire",
  "apropos.partners.media": "Média partenaire",
  "apropos.partners.investment": "Partenaire investissement",
  "apropos.partners.network": "Réseau d'incubateurs",
  "apropos.cta.title": "Rejoignez le mouvement",
  "apropos.cta.subtitle": "Vous avez une histoire à partager ? Vous connaissez un entrepreneur africain inspirant ? Contribuez à construire la plus grande bibliothèque de success stories africaines.",
  "apropos.cta.submit": "Soumettre une histoire",
  "apropos.cta.newsletter": "S'inscrire à la newsletter",

  // Soumettre page
  "soumettre.hero.title": "Soumettre votre histoire",
  "soumettre.hero.subtitle": "Partagez votre parcours entrepreneurial et inspirez des milliers de jeunes africains.",
  "soumettre.success.title": "Histoire soumise avec succès !",
  "soumettre.success.desc": "Notre équipe va examiner votre histoire et vous contactera sous 48h.",
  "soumettre.form.name": "Votre nom complet *",
  "soumettre.form.name.placeholder": "Ex: Aminata Koné",
  "soumettre.form.email": "Email *",
  "soumettre.form.country": "Pays *",
  "soumettre.form.country.select": "Sélectionner un pays",
  "soumettre.form.sector": "Secteur d'activité *",
  "soumettre.form.sector.select": "Sélectionner un secteur",
  "soumettre.form.company": "Nom de votre entreprise / projet *",
  "soumettre.form.company.placeholder": "Ex: AfriPay Solutions",
  "soumettre.form.story": "Votre histoire *",
  "soumettre.form.story.placeholder": "Racontez votre parcours, vos défis, vos réussites... (500 caractères max)",
  "soumettre.form.link": "Lien vers votre site / réseau social",
  "soumettre.form.submit": "Soumettre mon histoire",
  "soumettre.form.error": "Une erreur est survenue. Veuillez réessayer.",

  // Recherche page
  "recherche.title": "Recherche globale",
  "recherche.subtitle.results": "résultat pour",
  "recherche.subtitle.results_plural": "résultats pour",
  "recherche.subtitle.empty": "Explorez 500+ histoires d'entrepreneurs africains",
  "recherche.trends": "Tendances :",
  "recherche.filters.title": "Filtres",
  "recherche.filters.category": "Catégorie",
  "recherche.filters.sector": "Secteur",
  "recherche.filters.reset": "Réinitialiser les filtres",
  "recherche.sort.label": "Trier par :",
  "recherche.sort.relevance": "Pertinence",
  "recherche.sort.date": "Date",
  "recherche.sort.views": "Popularité",
  "recherche.empty.title": "Que cherchez-vous ?",
  "recherche.empty.desc": "Tapez le nom d'un entrepreneur, d'un pays, d'un secteur ou d'une startup africaine.",
  "recherche.noResults.title": "Aucun résultat",
  "recherche.noResults.desc": "Aucune histoire trouvée pour",
  "recherche.noResults.hint": "Essayez d'autres mots-clés.",
  "recherche.results.count": "résultat",
  "recherche.results.count_plural": "résultats",
  "recherche.results.for": "pour",
  "recherche.read": "Lire",
  "recherche.filterToggle": "Filtres",
  "recherche.filterHint": "Filtrer les résultats",

  // GlobalSearchBar
  "search.suggestions": "Suggestions",
  "search.loading": "Recherche en cours...",
  "search.seeAll": "Voir tous les résultats pour",
  "search.noResult": "Aucun résultat pour",
  "search.searchAnyway": "Rechercher quand même →",
  "search.browseCategory": "Parcourir par catégorie",
};

export default translations;
